<script setup lang="ts">
import InAppBrowserRedirect from '~/components/InAppBrowserRedirect.vue'
import PullToRefresh from '~/components/PullToRefresh.vue'

// Plugin에서 설정한 전역 상태 가져오기
const isInAppBrowser = useState('isInAppBrowser', () => false)
const isDetectionReady = useState('isDetectionReady', () => false)

// 클라이언트에서 감지 완료 대기
const showContent = ref(false)

onMounted(() => {
  // Plugin이 이미 실행됐거나, 즉시 감지 완료 확인
  if (isDetectionReady.value) {
    showContent.value = true
  } else {
    // Plugin 실행 대기 (최대 100ms)
    const checkInterval = setInterval(() => {
      if (isDetectionReady.value) {
        showContent.value = true
        clearInterval(checkInterval)
      }
    }, 10)

    // 타임아웃: 100ms 후에는 무조건 표시
    setTimeout(() => {
      showContent.value = true
      clearInterval(checkInterval)
    }, 100)
  }

  console.log('🔍 Layout - 인앱 브라우저:', isInAppBrowser.value, '감지 완료:', isDetectionReady.value)
})
</script>
<template>
  <InAppBrowserRedirect />
  <!-- 인앱 브라우저가 아닐 때만 서비스 화면 표시 -->
  <template v-if="showContent && !isInAppBrowser">
    <PullToRefresh />
    <slot></slot>
  </template>
</template>
<style>
@import '@/assets/css/style.css';
</style>
